import { render, staticRenderFns } from "./LocationList.vue?vue&type=template&id=4ff6765a&"
import script from "./LocationList.vue?vue&type=script&lang=ts&"
export * from "./LocationList.vue?vue&type=script&lang=ts&"
import style0 from "./LocationList.vue?vue&type=style&index=0&id=4ff6765a&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports